export default "__VITE_ASSET__CtjpNDCb__"